module.exports = __webpack_public_path__ + "img/b3-3.f1a6e4e.png";